import css from "./MessageButton.module.scss";

import React, { HTMLAttributes, useEffect, useState } from "react";
import { classNames } from "@greeter/util";

export type MessageButtonProps = Omit<
  HTMLAttributes<HTMLButtonElement>,
  "onClick"
> & {
  title?: string;
  message?: string;
  onClick?: (message: string) => void;
};

export const MessageButton: React.FC<MessageButtonProps> = ({
  className,
  children,
  title = "Placeholder",
  message = "Placeholder",
  onClick = (message: string) => {
    return;
  },
  ...props
}) => {
  return (
    <button
      {...props}
      onClick={(e) => void onClick(message)}
      {...classNames(css.MessageButton, className)}
    >
      + {title}
    </button>
  );
};
